import type { FeatureWithIDs } from '@/overmind/effects/adapters/baseadapter';

import type {
  ShortCircuitScenarioInputs,
  ShortCircuitScenarioStartValue
} from '../../..';
import { KiloAmperes } from '../../../domain/ElectricCurrent';
import {
  findGridElementLabel,
  findGridElementTitle
} from '../findGridElementLabel';
import type { ExternalNetworkInjectionShortCircuitDetails } from './ShortCircuitDetails';
import { Features } from '../../../createGridElementCalculationSetExecutionDetails';

export function createExternalNetworkInjectionsShortCircuitDetails(
  features: Features,
  inputs: ShortCircuitScenarioInputs[]
): ExternalNetworkInjectionShortCircuitDetails[] {
  return inputs.flatMap(inputs =>
    inputs.startValues.map(startValue =>
      createExternalNetworkInjectionShortCircuitDetails(startValue, features)
    )
  );
}
function createExternalNetworkInjectionShortCircuitDetails(
  startValue: ShortCircuitScenarioStartValue,
  features: Features
): {
  id: `{${string}}`;
  objectType: 'ExternalNetworkInjection';
  label: string;
  title: string;
  inputs: {
    maxInitialSymShCCurrent: KiloAmperes;
    minInitialSymShCCurrent: KiloAmperes;
    maxPowerFactor: number;
    minPowerFactor: number;
  };
} {
  return {
    id: startValue.connectedToId,
    objectType: 'ExternalNetworkInjection',
    label: findGridElementLabel(features, startValue.connectedToId),
    title: findGridElementTitle(features, startValue.connectedToId),
    inputs: {
      maxInitialSymShCCurrent: KiloAmperes.fromAmperes(
        startValue.maxInitialSymShCCurrent
      ),
      minInitialSymShCCurrent: KiloAmperes.fromAmperes(
        startValue.minInitialSymShCCurrent
      ),
      maxPowerFactor: startValue.powerFactorMax,
      minPowerFactor: startValue.powerFactorMin
    }
  };
}
